import React, { useEffect, useState } from "react";
import { ENGLISH, FRENCH, PREFFEREDLANGUAGE } from "../../App.config";
const PrefferedLanguage = (props) => {
  const initialState = {
    prefferedLang: {
      value:
        props?.managersDetails?.languagePreference === null ||
          props?.managersDetails?.languagePreference === undefined
          ? ""
          : props?.managersDetails?.languagePreference
            ? FRENCH
            : ENGLISH,
    },
  };

  const [state, setState] = useState(initialState);

  // Set state to initial state on change component
  useEffect(() => {
    return () => {
      setState((state) => {
        return {
          ...initialState,
        };
      });
    };
  }, []);

  const handleChanges = (event) => {
    let { name, value, checked, type } = event.target;

    let updatedObj = state[name];
    updatedObj.value = type === "checkbox" ? checked : value;

    setState((state) => {
      return {
        ...state,
        [name]: updatedObj,
      };
    });
  };

  const onSubmit = () => {
    let managersDetails = {
      ...props?.managersDetails,
      languagePreference: state.prefferedLang.value === FRENCH ? true : false,
    };
    props.updateManagersLanguagePreference(managersDetails);
  };

  return (
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            {/* {PREFFEREDLANGUAGE} */}
            {props.context.t("Setting.Preferred.Language.text")}
          </h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => props.closeRemoveModal()}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <span>
            <div className="col-3">
              <div className="form-group">
                <label htmlFor="">&nbsp;</label>
                <li className="Radio-box">
                  <div className="check-col">
                    <input
                      tabIndex="-1"
                      type="radio"
                      id="lang-English"
                      name="prefferedLang"
                      value={ENGLISH}
                      checked={state.prefferedLang.value === ENGLISH}
                      onChange={handleChanges}
                    />
                    <label htmlFor="lang-English">{props.context.t("AIR-Employee-Information.form.label.text.EmployeePrefLang.Eng")}</label>
                  </div>
                  <div className="check-col">
                    <input
                      type="radio"
                      tabIndex="-1"
                      id="lang-french"
                      name="prefferedLang"
                      value={FRENCH}
                      checked={state.prefferedLang.value === FRENCH}
                      onChange={handleChanges}
                    />
                    <label htmlFor="lang-french">{props.context.t("AIR-Employee-Information.form.label.text.EmployeePrefLang.Fr")}</label>
                  </div>
                </li>
              </div>
            </div>
          </span>
        </div>
        <div className="modal-footer">
          <button onClick={onSubmit} type="button" className="btn btn-primary">
            {props.context.t("Setting.Update.text")}
          </button>
        </div>
      </div>
    </div>
  );
};
export default PrefferedLanguage;
